module.exports = __webpack_public_path__ + "img/VCB.7e9bb0c6.png";